module.exports = __webpack_public_path__ + "img/12_1802_precious_wood.0fd3a20b.jpg";